// extracted by mini-css-extract-plugin
export default {"form":"LogInModal_form__E0AOQ","text":"LogInModal_text__8NL08"};